import { createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { isSubscriptionLoading } from '../../_selectors/isSubscriptionLoading.selector';
import { availableAlertSubscriptionsSelector } from '../../_selectors/availableAlertSubscriptions.selector';

export const alertSettingsDataGridSelector = createCachedSelector(
  [
    availableAlertSubscriptionsSelector,
    isSubscriptionLoading,
  ],
  (subscriptions, isLoading) => {
    return {
      subscriptions,
      isLoading,
    };
  },
)({
  keySelector: defaultKeySelector,
});
